import { render, staticRenderFns } from "./StaffPscCompanyInstruction.vue?vue&type=template&id=2a59dccc&scoped=true&"
import script from "./StaffPscCompanyInstruction.vue?vue&type=script&lang=js&"
export * from "./StaffPscCompanyInstruction.vue?vue&type=script&lang=js&"
import style0 from "./StaffPscCompanyInstruction.vue?vue&type=style&index=0&id=2a59dccc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a59dccc",
  null
  
)

export default component.exports